import { Directive, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocationState } from '../../../core/models/proprietary/contract/location.state';

@Directive({
    selector: '[epLocationSublocation]',
    standalone: false
})
export class LocationSublocationDirective implements OnDestroy {
    private locNumSubject = new BehaviorSubject(null);
    public locNum$ = this.locNumSubject.asObservable();

    private locIdSubject = new BehaviorSubject(null);
    public locId$ = this.locIdSubject.asObservable();
    locIdSub: Subscription;

    constructor(private store: Store) { }

    updateLocNum(locNum) {
        this.locNumSubject.next(locNum);
        this.locIdSub = this.store
            .select(LocationState.locIDByLocNum)
            .pipe(map((fn) => fn(locNum)))
            .subscribe((locId) => {
                this.locIdSubject.next(locId);
            });
    }

    updateLocID(locId) {
        this.locIdSubject.next(locId);
    }

    ngOnDestroy() {
        if (this.locIdSub) {
            this.locIdSub.unsubscribe();
        }
    }
}
